"use client";
import { StaticImageData } from "next/image";
import ToolFeaturedArea, {
  THeroSectionInfoType,
} from "@/components/tools/ToolFeatured/ToolFeaturedArea";
import AdBanner from "@/components/Advertisement/AdBanner";
import SummarizerCoreSection from "@/components/tools/ToolFunctional/summarizer/SummarizerCoreSection";
import CommonTitle from "@/components/common/CommonTitle";
import CommonSubtitle from "@/components/common/CommonSubtitle";
import ConclusionSection, {
  ConclusionSectionFeatureProps,
} from "@/components/tools/ToolsCommon/ConclusionSection";
import InfoSection, {
  InfoSectionFeatureProps,
} from "@/components/tools/ToolsCommon/InfoSection";
import ToolTopArea from "@/components/tools/ToolTop/ToolTopArea";
import AiToolsFaq, {
  IFaqList,
} from "@/components/tools/ToolsCommon/AiToolsFaq";
import AdvTools from "@/components/tools/AdvTools/AdvTools";

export interface PageInfoProps {
  title: string;
  subtitle: string;
}

export type TAIPropTypes = {
  params: {
    pageInfo: PageInfoProps;
    pageBottom: PageInfoProps;
    heroSectionInfo: THeroSectionInfoType;
    infoSectionFeatures: InfoSectionFeatureProps[];
    conclusionSectionFeatures: ConclusionSectionFeatureProps[];
    stepsSectionFeatures: ConclusionSectionFeatureProps[];
    faqList: IFaqList[];
  };
};

export type TFeatureList = {
  title: string;
  subtitle: string;
  featuredImg: StaticImageData;
};

const SummarizerPageRoot = ({ params }: TAIPropTypes) => {
  const {
    pageInfo,
    pageBottom,
    heroSectionInfo,
    conclusionSectionFeatures,
    infoSectionFeatures,
    stepsSectionFeatures,
    faqList,
  } = params;
  return (
    <>
      <ToolTopArea pageInfo={params.pageInfo}>
        <div className="relative z-10 w-full overflow-hidden">
          <SummarizerCoreSection />
        </div>
      </ToolTopArea>
      <AdvTools
        title={<>Get Kroolo, The best of
          {" "}
          <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
            AI Summarizer
          </span>
        </>
        }
        btnText="Try it free"
      />
      <ConclusionSection
        title="Summarize text instantly with an AI summarizer tool"
        subtitle="Generate accurate, fast, and insightful summaries using Kroolo’s summarizing tool, simplifying complex documents into easy-to-read formats while preserving key details."
        featureArray={stepsSectionFeatures}
      />
      <InfoSection
        title="Why Choose Kroolo AI's Summarizing Tool?"
        subtitle="Achieve precise, fast, and insightful summaries with AI, turning complex documents into easy-to-understand formats while retaining essential information."
        featureArray={infoSectionFeatures}
      />
      <ConclusionSection
        title="Who can use Kroolo AI's Summarizing Tool?"
        featureArray={conclusionSectionFeatures}
      />
      <ToolFeaturedArea heroSectionInfo={heroSectionInfo} />
      <div className="container mx-auto my-24 mb-12 max-w-[900px] space-y-4 text-center xl:my-32 xl:mb-16 3xl:my-40 3xl:mb-16">
        <CommonTitle
          as="h3"
          color="#202020"
          fontWeightClass="font-semibold"
          fontSizeClass="text-[26px] xl:text-[28px]"
        >
          {pageBottom.title}
        </CommonTitle>
        <CommonSubtitle
        >
          {pageBottom.subtitle}
        </CommonSubtitle>
      </div>
      <AiToolsFaq faqTitle="AI Summarizer FAQs" faqList={faqList} />
      <AdBanner />
    </>
  );
};

export default SummarizerPageRoot;
